import React, { useMemo } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { useAppContext } from "~/contexts/appContext";
import { isTreasuryPlatformManager } from "~/utils/userRoles";
import * as styles from "./styles_vanilla.css";
import { ToolCard } from "./ToolCard";
import { ToolCategory } from "./types";

export type CategoryCardProps = {
  category: ToolCategory;
  onToolClick: (path: string) => void;
};

export const CategoryCard: React.FC<CategoryCardProps> = ({ category, onToolClick }) => {
  const { user } = useAppContext();

  // Filter tools based on user permissions. Each tool can define a checkPermission
  // function in constants.ts. Tools without checkPermission default to platform manager only.
  const visibleTools = useMemo(() => {
    return category.tools.filter((tool) => {
      if (tool.checkPermission) {
        return tool.checkPermission(user.roles);
      }
      return isTreasuryPlatformManager(user.roles);
    });
  }, [category.tools, user.roles]);

  if (visibleTools.length === 0) {
    return null;
  }

  return (
    <div className={styles.categoryCard}>
      <Flex flexDirection="column" gap={Sizes.LG}>
        <Text variant="strong-lg">{category.title}</Text>
        <div className={styles.toolsGrid}>
          {visibleTools.map((tool) => (
            <ToolCard key={tool.title} tool={tool} onClick={onToolClick} />
          ))}
        </div>
      </Flex>
    </div>
  );
};
